import { RegisterFormProps } from '../../../types';
import './register-form.css';

function RegisterForm( props: RegisterFormProps) {
    return (
        <form id="register-form" action={props.action} method={props.method}>
            {props.children}
        </form>
    );
}

export default RegisterForm;